import React from "react";
import {ConfirmDialogProps} from "./types";
import {Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
    title,
    description,
    open,
    onCancel,
    onConfirm,
    confirmText,
    loading = false,
}) => {
    const {t} = useTranslation();


    return (
        <Dialog
            open={open}
            onClose={() => {
                if (loading) {
                    return;
                }
                onCancel();
            }}
            fullWidth={true}
            maxWidth="md"
        >

            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <Typography
                    sx={{color: 'text.primary', paddingY: '10px'}}>
                    {description}

                </Typography>
            </DialogContent>
            <DialogActions>
                <Button  variant={'contained'} disabled={loading} onClick={() => {
                    onConfirm();
                }}>
                    {confirmText}
                    {loading && <CircularProgress sx={{marginLeft: '10px'}} size={20} color={'inherit'}/>}
                </Button>
                <Button disabled={loading} onClick={() => {
                    onCancel();
                }}>{t('common.closeWindow')}</Button>

            </DialogActions>


        </Dialog>

    )
}


export default ConfirmDialog;